var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowentiChatMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2B4C7E",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78 92              H 322              a 30 30 0 0 1 30 30              V 232              a 30 30 0 0 1 -30 30              H 188              l -44 46              v -46              H 78              a 30 30 0 0 1 -30 -30              V 122              a 30 30 0 0 1 30 -30 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 177,
    r: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 177,
    x2: 178,
    y2: 177
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 153 L 224 177 L 200 201 L 176 177 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 169,
    x2: 208,
    y2: 185
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 185,
    x2: 208,
    y2: 169
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224,
    y1: 177,
    x2: 262,
    y2: 177
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 177,
    r: 19,
    strokeWidth: 14
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowentiChatMark);
export default __webpack_public_path__ + "static/media/flowenti-chat-mark.6a0af550d84564ffb798d9855760ee0e.svg";
export { ForwardRef as ReactComponent };